module.exports = __webpack_public_path__ + "videos/oabot_bg_high.678ced7.mp4";